<template>
  <div class="container-fluid">
    <h2 class="page-heading">Режим работы</h2>
    <div class="table-full-width">
      <table class="table-machine-schedule table" v-if="machine">
        <tr v-for="(weekday, index) in weekdays" :class="{'text-gray': !weekday.enabled}">
          <td class="weekday-label">{{ weekdayLabel(index) }}</td>
          <td class="day-checkbox">
            <input class="form-check-inline m-0" type="checkbox" v-model="weekday.enabled">
          </td>
          <td class="schedule-display">
            {{ formatToDate(weekday.range[0]) }} – {{ formatToDate(weekday.range[1]) }}
          </td>
          <td class="pr-5">
            <el-slider
              v-model="weekday.range"
              range
              showTooltip
              :formatTooltip="formatToDate"
              :max="24 * 60"
              :step="15"
              :disabled="!weekday.enabled"
            >
            </el-slider>
          </td>
        </tr>
      </table>
    </div>

    <btn-action class="btn btn-primary" @click="saveSchedule" v-if="$root.checkPermission('web_ta_schedule_edit')">Сохранить</btn-action>
  </div>
</template>

<script>
  import moment from 'moment'
  import api from '@/api'
  import {range} from 'lodash'

  export default {
    props: {
      id: {
        required: true,
      },
      machine: {
        type: Object,
      },
    },
    data () {
      return {
        weekdays: [],
      }
    },
    methods: {
      weekdayLabel: (i) => moment().weekday(i).format('dddd'),
      saveSchedule () {
        const workTime = this.weekdays.map((day, index) => {
          if (!day.enabled) return null
          const [from, till] = day.range.map(this.formatToDate)
          return {
            day_of_week: index + 1,
            open_time: from,
            close_time: till,
          }
        }).filter(item => item)

        return api.put(`machines/${this.id}`, {
          work_time: workTime,
        }).then(() => {
          this.machine.work_time = workTime
        })
      },
      formatToDate (value) {
        const minutes = parseInt(value)
        if (minutes === 24 * 60) {
          return '24:00'
        }
        if (isNaN(minutes)) return null
        return moment().hour(0).minute(minutes).format('HH:mm')
      },
    },
    created () {
      this.weekdays = range(1, 8).map((index) => {
        let day = (this.machine.work_time || []).find((day) => day.day_of_week === index)
        return (day === undefined) ? {
          enabled: false,
          range: [480, 1200],
        } : {
          enabled: true,
          range: [day.open_time, day.close_time].map((time) => {
            let [hours, minutes] = time.split(':')
            return 60 * hours + Number(minutes)
          }),
        }
      })
    },
  }
</script>

<style lang="scss">
  @import "boot";
  .table-machine-schedule {
    td {
      vertical-align: middle;
    }
    .weekday-label {
      text-transform: capitalize;
      font-weight: $font-weight-bold;
      width: 1px;
      text-align: right;
      padding-left: $grid-gutter-width / 2;
    }
    .day-checkbox {
      width: 1px;
    }
    .schedule-display {
      width: 1px;
      white-space:nowrap;
    }
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/machines/_id/schedule.vue